import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locales/en.json';
import zhTranslations from '../locales/zh.json';

const resources = {
  en: { translation: enTranslations },
  zh: { translation: zhTranslations },
};

function applyDocumentLang(lng: string) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lng.startsWith('zh') ? 'zh-Hans' : 'en';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    debug: process.env.NODE_ENV === 'development',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'simpian-lang',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

applyDocumentLang(i18n.resolvedLanguage || i18n.language || 'en');
i18n.on('languageChanged', applyDocumentLang);

export default i18n;
